import React from 'react';
import { ToastContainer } from 'react-toastr';
import { graphql } from 'react-apollo';
import SEND_MASS_MUTATION from '../../../graphql/SendMass';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import Sidebar from '../../../components/Sidebar/index';
import Form from './form';

class MassiveMailer extends React.PureComponent {
  sendMails = (values) => {
    const { mutate } = this.props;

    mutate({
      variables: values,
    })
      .then(() => {
        this.toastr.success('Mensaje encolado correctamente para su envío');
      })
      .catch((err) => {
        this.toastr.error('Ocurrió un problema al encolar el envío');
      });
  };

  onLogout = () => {
    this.props.history.push('/login');
  };

  render() {
    return (
      <div>
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="mailer" onLogout={this.onLogout} />
              </div>
              <div className="col-lg-9 col-md-9 col-sm-12 submit-address">
                <h1 className="heading">Mensajería masiva</h1>
                <Form
                  onSubmit={this.sendMails}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withMutation = graphql(SEND_MASS_MUTATION);

export default withMutation(MassiveMailer);



// WEBPACK FOOTER //
// ./src/containers/Admin/MassiveMailer/index.js